function showMore() {
    showMore = document.getElementById("showMore");

    if (showMore) {
        showMore.addEventListener("click", function () {
            var i = document.getElementById("courseInstances");

            [...i.children].forEach((element) => element.classList.remove("hidden"));
            this.setAttribute("disabled", "disabled")
        });
    }
}